package com.futurions.portfolio.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.functions.blur
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.icons.fa.FaBars
import com.varabyte.kobweb.silk.components.layout.Surface

import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.*
import kotlinx.browser.document
import kotlinx.browser.window
import kotlin.time.Duration

@Composable
fun Navbar() {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(20.px)
            .backgroundColor(rgba(0, 0, 0, 0.35))
            .backdropFilter(blur(12.px))
            .borderRadius(18.px)
            .boxShadow(
                blurRadius = 20.px,
                spreadRadius = 2.px,
                color = rgba(0, 255, 255, 0.15)
            )
            .position(Position.Sticky)
            .top(20.px)
            .zIndex(50)
            .justifyContent(JustifyContent.SpaceBetween),
        verticalAlignment = Alignment.CenterVertically
    ) {

        /** LEFT SIDE — NAME **/
        SpanText(
            text = "Gaurav Singh",
            modifier = Modifier
                .fontSize(22.px)
                .fontWeight(FontWeight.Bold)
                .color(Colors.White)
                .letterSpacing(1.px)
                .cursor(Cursor.Pointer)
                .onClick {
                    // Scroll to top smoothly
                    window.scrollTo(js("{ top: 0, behavior: 'smooth' }"))
                }
        )

        /** RIGHT SIDE MENU **/
        Row(
            modifier = Modifier.gap(32.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            NavItem("About", "about")
            NavItem("Skills", "skills")
            NavItem("Projects", "projects")
            NavItem("Resume", "resume")
            NavItem("Contact", "contact")
        }
    }
}


@OptIn(DelicateApi::class)
//@Composable
//fun Navbar() {
//    val breakpoint = rememberBreakpoint()
//    var menuOpen by remember { mutableStateOf(false) }
//
//    Surface(
//        modifier = Modifier
//            .fillMaxWidth()
//            .padding(leftRight = 16.px, bottom = 16.px)
//            .justifyContent(JustifyContent.SpaceBetween)
//            .position(Position.Sticky)
//            .top(0.px)
//            .zIndex(10)
//            .backgroundColor(rgba(0, 0, 0, 0.4))
//            .backdropFilter(blur(10.px))
//            .borderRadius(12.px)
//            .boxShadow(blurRadius = 10.px, color = rgba(0, 0, 0, 0.3)),
//
//    ) {
//        SpanText(
//            text = "Gaurav Singh",
//            modifier = Modifier
//                .fontSize(22.px)
//                .fontWeight(FontWeight.Bold)
//                .color(rgb(255, 255, 255))
//        )
//
//        if (breakpoint >= Breakpoint.MD) {
//            // 💻 Desktop layout
//            Row(modifier = Modifier.gap(24.px)) {
//                NavItem("About", "about")
//                NavItem("Projects", "projects")
//                NavItem("Resume", "resume")
//                NavItem("Contact", "contact")
//            }
//        } else {
//            // 📱 Mobile layout
//            FaBars(
//                modifier = Modifier
//                    .fontSize(24.px)
//                    .color(rgb(255, 255, 255))
//                    .onClick { menuOpen = !menuOpen }
//            )
//
//            if (menuOpen) {
//                Column(
//                    modifier = Modifier
//                        .position(Position.Absolute)
//                        .top(60.px)
//                        .right(16.px)
//                        .backgroundColor(rgba(0, 0, 0, 0.85))
//                        .padding(16.px)
//                        .borderRadius(8.px)
//                        .gap(12.px)
//                        .zIndex(15)
//                ) {
//                    NavItem("About", "about", true)
//                    NavItem("Projects", "projects", true)
//                    NavItem("Resume", "resume", true)
//                    NavItem("Contact", "contact", true)
//                }
//            }
//        }
//    }
//}

@Composable
fun NavItem(text: String, sectionId: String, closeMenu: Boolean = false) {
    SpanText(
        text = text,
        modifier = Modifier
            .fontSize(16.px)
            .color(rgb(255, 255, 255))
            .cursor(Cursor.Pointer)
            .onClick {
                val element = document.getElementById(sectionId)
                element?.scrollIntoView(js("{ behavior: 'smooth' }"))
            }

    )
}
